import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { weatherMapData } from '../data/mockData';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default markers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const WeatherMap = () => {
  const [selectedMetric, setSelectedMetric] = useState('temperature');
  
  const getRiskColor = (risk) => {
    switch(risk) {
      case 'Low': return 'bg-green-100 text-green-800';
      case 'Medium': return 'bg-yellow-100 text-yellow-800';
      case 'High': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getMetricValue = (data, metric) => {
    switch(metric) {
      case 'temperature': return `${data.temp}°C`;
      case 'precipitation': return `${data.precip}mm`;
      case 'risk': return data.risk;
      default: return data.temp;
    }
  };

  return (
    <Card className="w-full h-full">
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <span>Weather Conditions Map</span>
          <div className="flex gap-2">
            <button
              onClick={() => setSelectedMetric('temperature')}
              className={`px-3 py-1 rounded text-sm font-medium transition-all ${
                selectedMetric === 'temperature'
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              Temperature
            </button>
            <button
              onClick={() => setSelectedMetric('precipitation')}
              className={`px-3 py-1 rounded text-sm font-medium transition-all ${
                selectedMetric === 'precipitation'
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              Precipitation
            </button>
            <button
              onClick={() => setSelectedMetric('risk')}
              className={`px-3 py-1 rounded text-sm font-medium transition-all ${
                selectedMetric === 'risk'
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              Risk Level
            </button>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent className="h-96 p-0">
        <MapContainer
          center={[52.5, -106.5]}
          zoom={4}
          style={{ height: '100%', width: '100%' }}
          className="rounded-lg"
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          {weatherMapData.map((location, index) => (
            <Marker
              key={index}
              position={[location.lat, location.lng]}
            >
              <Popup>
                <div className="space-y-2">
                  <h3 className="font-bold text-lg">{location.province}</h3>
                  <div className="space-y-1">
                    <p className="text-sm">
                      <span className="font-medium">Temperature:</span> {location.temp}°C
                    </p>
                    <p className="text-sm">
                      <span className="font-medium">Precipitation:</span> {location.precip}mm
                    </p>
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium">Risk Level:</span>
                      <Badge className={getRiskColor(location.risk)}>
                        {location.risk}
                      </Badge>
                    </div>
                  </div>
                  <div className="text-xs text-gray-500 mt-2">
                    Current Year Average
                  </div>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </CardContent>
    </Card>
  );
};

export default WeatherMap;